module.exports = __webpack_public_path__ + "img/files2.3bb82af3.svg";